<template>
  <SharedCredentialForm v-if="user" :user="user" :isEdit="false"/>
</template>

<script>

import SharedCredentialForm from "@/modules/Admin/Components/SharedCredentials/SharedCredentialForm.vue";

export default {
  name: "CreateSharedCredentialPage",
  components: {SharedCredentialForm},

  data() {
    return {
      user: {
        username: '',
        type: 'editor',
        scoped_roles: [],
        credential: {
          usage_plan: {
            id: null,
          },
          api_key: {
            id: null,
          },
          contact_emails: [],
          internal_owner: '',
          description: '',
        }
      },
    }
  },
};
</script>
